import { Grid, TextField } from '@mui/material';
import { FixedSizeList } from 'react-window';
import { VideoTranscript } from '../../types/videoTranscript';

type VideoTranscriptProps = {
  transcript: VideoTranscript,
}

const TranscriptSegment = ({ startTime, endTime, transcript }) => (
  <Grid container spacing={2} alignItems="center" sx={{ mb: 1 }}>
    <Grid item xs={12}>
      <Grid container spacing={2} alignItems="center">
        <Grid item>
          <span>Start: {startTime}s</span>
        </Grid>
        <Grid item><span>/</span></Grid>
        <Grid item>
          <span>End: {endTime}s</span>
        </Grid>
      </Grid>
    </Grid>
    <Grid item xs={12}>
      <TextField
        multiline
        fullWidth
        value={transcript}
        InputProps={{
          readOnly: true,
        }}
      />
    </Grid>
  </Grid>
);

export const TranscriptV2Panel = ({ transcript }: VideoTranscriptProps) => {
  const data = transcript.items.length > 0
    ? transcript.items.map(({ id, start_time, end_time, alternatives }) => ({
        key: id,
        startTime: start_time,
        endTime: end_time,
        transcript: alternatives[0].content
      }))
    : transcript.audio_segments.map(({ transcript: text, start_time, end_time }, index) => ({
        key: index,
        startTime: start_time,
        endTime: end_time,
        transcript: text
      }));

  // Row renderer for virtualized list
  const Row = ({ index, style }) => {
    const item = data[index];
    return (
      <div style={style}>
        <TranscriptSegment
          startTime={item.startTime}
          endTime={item.endTime}
          transcript={item.transcript}
        />
      </div>
    );
  };

  return (
    <FixedSizeList
      height={520}
      itemCount={data.length}
      itemSize={120}
      width="100%"
    >
      {Row}
    </FixedSizeList>
  );
};
